import { createComponent } from "@helpers/admin";
import FeaturesSectionComponent from "@template/blocks/FeaturesSection/component";

export const Features = createComponent({
  label: "Features",
  component: (props) => <FeaturesSectionComponent {...props} />,
  fields: {
    heading: {
      label: "Heading",
      type: "textarea",
    },
    subHeading: {
      label: "Sub Heading",
      type: "textarea",
    },
    largeFeatureIcons: {
      label: "Large Feature Icons",
      type: "boolean",
    },
    features: {
      label: "Features",
      type: "array",
      default_items: 1,
      arrayFields: {
        heading: {
          label: "Heading",
          type: "textarea",
        },
        subHeading: {
          label: "Description",
          type: "markdown",
        },
        iconName: {
          label: "Icon",
          type: "icon",
        },
        image: {
          label: "Image",
          type: "image",
        },
        cta: {
          label: "CTA",
          type: "object",
          objectFields: {
            text: {
              label: "Text",
              type: "textarea",
            },
            link: {
              label: "Link",
              type: "textarea",
            },
            target: {
              label: "Target",
              type: "radio",
              options: [
                {
                  label: "Blank",
                  value: "_blank",
                },
                {
                  label: "Self",
                  value: "_self",
                },
              ],
            },
          },
        },
        color: {
          label: "Color",
          type: "select",
          options: [
            { label: "Primary", value: "primary" },
            { label: "Secondary", value: "secondary" },
            { label: "Default", value: "default" },
          ],
        },
        type: {
          label: "Variant",
          type: "select",
          options: [
            { label: "Block", value: "block" },
            { label: "Card", value: "card" },
          ],
        },
        small: {
          label: "Small",
          type: "boolean",
        },
        large: {
          label: "Large Icon",
          type: "boolean",
        },
        filled: {
          label: "Filled",
          type: "boolean",
        },
      },
    },
    column: {
      label: "Column",
      type: "boolean",
    },
    altBackground: {
      label: "Alternative Background",
      type: "boolean",
    },
  },
});
